import React from "react";
import { motion } from "framer-motion";

const AccoladesAchievements = () => {
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: { staggerChildren: 0.15 },
        },
    };

    const fadeUpVariants = {
        hidden: { opacity: 0, y: 30 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.7, ease: "easeOut" } },
    };

    const imageVariants = {
        hidden: { opacity: 0, scale: 0.96 },
        visible: { opacity: 1, scale: 1, transition: { duration: 0.8, ease: "easeOut" } },
    };

    return (
        <section className="w-full bg-white pb-12 sm:pb-16 md:pb-20 lg:pb-24 text-left relative z-10 overflow-hidden">
            <div className="max-w-[1440px] mx-auto w-full flex flex-col lg:grid lg:grid-cols-12 gap-8 lg:gap-16 items-center px-5 sm:px-10 lg:px-[80px]">

                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, margin: "-100px" }}
                    variants={imageVariants}
                    className="w-full lg:col-span-5 flex justify-center lg:justify-start"
                >
                    <div className="w-full max-w-[500px] lg:max-w-none aspect-[4/3] sm:aspect-[16/10] lg:aspect-[4/3] overflow-hidden relative bg-[#020617]">
                        <motion.img
                            whileHover={{ scale: 1.03 }}
                            transition={{ duration: 0.6 }}
                            src="/assets/diversity/img7.png"
                            alt="Accolades and achievements grid pattern background with walking silhouettes"
                            className="w-full h-full object-cover absolute inset-0"
                        />
                    </div>
                </motion.div>

                <motion.div
                    variants={containerVariants}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, margin: "-100px" }}
                    className="w-full lg:col-span-7 flex flex-col min-w-0 gap-4 sm:gap-5"
                >
                    <motion.h2
                        variants={fadeUpVariants}
                        className="text-[20px] md:text-[30px] font-[600] font-sora text-[#01386A] leading-tight tracking-tight"
                    >
                        Accolades & Achievements in D&I
                    </motion.h2>

                    <motion.p
                        variants={fadeUpVariants}
                        className="text-[14px] sm:text-[16px] font-graphik font-[500] text-[#49577A] leading-relaxed break-words"
                    >
                        As Cybage prepares for a post-pandemic future, our values will continue to evolve. We are determined to connect these to our organization's purpose to bring unity among all. Cybage will continue to focus on its core values and initiatives of diversity and inclusion that have helped in sparking a quick recovery and sustainable growth for the business. We will continue to acknowledge the importance of these values and take it a notch higher.
                    </motion.p>

                    <motion.ul
                        variants={fadeUpVariants}
                        className="w-full pl-1 flex flex-col gap-3 sm:gap-4 mt-2"
                    >
                        {[
                            "Recognized by the National Association of Software and Services Companies (NASSCOM) For 'Excellence in Diversity and Inclusion' at the NASSCOM Corporate Awards 2019",
                            "Rated 3.9 for Culture & Values on Glassdoor",
                            "Rated 3.8 for Diversity & Inclusion on Glassdoor",
                            "Received public recognition for gender equality policies, practices, and processes"
                        ].map((achievement, index) => (
                            <li
                                key={index}
                                className="flex items-start gap-3 w-full text-[13px] sm:text-[14px] md:text-[16px] font-[500] font-graphik text-[#49577A] leading-relaxed break-words"
                            >
                                <span className="text-[#49577A] text-[16px] leading-none select-none pt-0.5">•</span>
                                <span className="flex-1">{achievement}</span>
                            </li>
                        ))}
                    </motion.ul>
                </motion.div>

            </div>
        </section>
    );
};

export default AccoladesAchievements;